import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";

import { App } from "./App.tsx";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  integrations: [],
  tracesSampleRate: 1.0,
  release: __SENTRY_RELEASE__,
  environment: import.meta.env.MODE,
});

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
    <App />
  </Sentry.ErrorBoundary>,
);
